import React from 'react';
import logoDaroma from '../../../media/img/clients/logoDaroma.png';
import logoOlawee from '../../../media/img/clients/logoOlawee.png';
import logoSubtilly from '../../../media/img/clients/logoSubtilly.png';
import './clientsSection.scss';

const clients = [
  { id: 1, name: 'Daroma Innovations', logo: logoDaroma },
  { id: 2, name: 'Olawee', logo: logoOlawee },
  { id: 3, name: 'Subtilly', logo: logoSubtilly },
];

const ClientsSection = () => {
  return (
    <div className="clientsSection">
      <h2 className="clientsSection__title">NUESTROS CLIENTES</h2>
      <div className="clientsSection__line" />
      <p className="clientsSection__subtitle">
        Empresas y organizaciones que confían en Wonderaly para transformar sus
        producciones con neuropsicología aplicada.
      </p>
      <div className="clientsSection__grid">
        {clients.map((client) => (
          <div key={client.id} className="clientsSection__item">
            <img
              src={client.logo}
              alt={client.name}
              className="clientsSection__logo"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientsSection;
